<template>
  <div class="q-pa-md q-gutter-sm">
    <q-breadcrumbs>
      <q-breadcrumbs-el icon="home" to="/" />
      <q-breadcrumbs-el label="banner" icon="image" to="/mp/banner" />
    </q-breadcrumbs>
    <q-responsive :ratio="1920 / 751" style="max-width: 100%">
      <q-carousel
        animated
        v-model="slide"
        arrows
        navigation
        infinite
        :autoplay="autoplay"
        transition-prev="slide-right"
        transition-next="slide-left"
        @mouseenter="autoplay = false"
        @mouseleave="autoplay = true"
      >
        <q-carousel-slide
          v-for="(item, index) in bannerList"
          :key="item.id"
          :name="index"
          :img-src="item.picture"
        />
        <template v-slot:control>
          <q-carousel-control
            position="bottom-right"
            :offset="[18, 18]"
            class="q-gutter-xs"
            v-if="bannerList.length > 0"
          >
            <q-btn
              push
              round
              dense
              color="orange"
              text-color="black"
              icon="update"
              @click="toUpdate"
            />
            <q-btn
              push
              round
              dense
              color="red"
              text-color="black"
              icon="delete"
              @click="remove"
            />
          </q-carousel-control>
        </template>
      </q-carousel>
    </q-responsive>

    <div class="row q-col-gutter-md justify-center">
      <div class="col-12">
        <q-space />
      </div>
      <div class="col-12">
        <q-space />
      </div>
      <div class="col-12">
        <q-space />
      </div>
      <div class="col-12" style="text-align: center">
        <q-btn
          rounded
          color="secondary"
          icon="photo"
          label="添加图片"
          @click="visible = true"
        />
      </div>
    </div>

    <q-dialog v-model="visible">
      <q-card style="max-height: 80vh; width: 600px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">banner设置</div>
        </q-card-section>

        <q-separator />

        <q-card-section class="scroll" style="max-height: 80vh">
          <div class="q-gutter-y-md column">
            <q-uploader
              ref="uploader"
              label="图片"
              :url="url"
              :headers="headers"
              field-name="file"
              color="teal"
              flat
              bordered
              @uploaded="uploaded"
              @removed="removed"
              style="width: 100%"
            >
            </q-uploader>
            <q-input v-model="banner.url" label="路由" outlined clearable>
            </q-input>
            <q-input v-model="banner.seq" label="排序" outlined clearable>
            </q-input>
            <div>
              <q-toggle
                v-model="banner.available"
                color="green"
                label="是否可用"
                false-value="0"
                true-value="1"
                left-label
              />
            </div>
            <q-input
              outlined
              v-model="banner.remark"
              label="备注"
              type="textarea"
              clearable
            >
            </q-input>
          </div>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn flat label="取消" color="primary" @click="visible = false" />
          <q-btn flat label="保存" color="primary" @click="save" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { save, list, update, remove } from "@/api/mp/banner";
import { getImageFileFromUrl } from "@/utils/file";
export default {
  data() {
    return {
      slide: 0,
      autoplay: true,
      visible: false,
      banner: {},
      bannerList: [],
      headers: [
        {
          name: "Authorization",
          value: "Bearer " + localStorage.getItem("token"),
        },
      ],
      url: process.env.VUE_APP_BASE_URL + "file/banner/upload",
    };
  },
  methods: {
    save() {
      var self = this;
      if (this.banner.id) {
        update(this.banner).then(() => {
          self.visible = false;
          self.$q.notify({ type: "positive", message: "更新成功" });
          self.list();
        });
      } else {
        save(this.banner).then(() => {
          self.visible = false;
          self.$q.notify({ type: "positive", message: "保存成功" });
          self.list();
        });
      }
    },
    list() {
      var self = this;
      list().then((response) => {
        self.bannerList = response.data.data;
      });
    },
    remove() {
      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "此操作将永久删除该图片, 是否继续?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          var self = this;
          let id = this.bannerList[this.slide].id;
          remove(id).then(() => {
            self.visible = false;
            self.$q.notify({ type: "positive", message: "删除成功" });
            self.list();
          });
        })
        .onCancel(() => {})
        .onDismiss(() => {
          console.log("I am triggered on both OK and Cancel");
        });
    },
    toUpdate() {
      this.visible = true;
      this.banner = JSON.parse(JSON.stringify(this.bannerList[this.slide]));
      var fileList = [];
      getImageFileFromUrl(this.banner.picture).then(
        (file) => {
          fileList.push(file);
          this.$nextTick(() => {
            this.$refs.uploader.addFiles(fileList);
          });
        }
      );
    },
    uploaded(info) {
      console.log(info.xhr);
      var res = JSON.parse(info.xhr.response);
      this.$set(this.banner, "picture", res.data.url);
    },
    removed(files) {
      console.log(files);
      this.banner.picture = null;
    },
  },
  mounted() {
    console.log("banner test");
    this.list();
  },
};
</script>

<style scoped>
</style>